import { getFeatureStatus } from "../CommonUtils";
import { FEATURES } from "../constants/CommonConstants";

const MAX_EXPORT_ROWS = 250000;
export const ONE_SECOND_DELAY_MS = 1000;

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


/**
 * Fetches data from getDrillDownData API with pagination support.
 * @param {object} baseRequestBody - The request body (nodeId, packageStatusMap, filters, etc.)
 * @param {function} apiCaller - Async function that takes a request object and returns a response
 * @param {object} options - Optional: { transformFn, startingIndex }
 * @returns {Promise<{results: Array, totalRowCount: number}>} - Accumulated results and count
 */
export async function paginatedFetch(baseRequestBody, apiCaller, options = {}) {
    const { transformFn = (r) => r, startingIndex = 0, maxRows = MAX_EXPORT_ROWS } = options;
    let paginationToken = null;
    let results = [];
    let totalRowCount = 0;

    const isOneSecDelayEnabled = await getFeatureStatus(FEATURES.IS_DRILL_DOWN_PAGINATED_ONE_SEC_DELAY_ENABLED);

    do {
        const requestBody = { ...baseRequestBody, "startingIndex": paginationToken ? 0 : startingIndex };
        if (paginationToken) {
            requestBody.paginationToken = paginationToken;
        }

        const request = {
            resourcePath: "/os/getDrillDownData",
            httpMethod: "post",
            processName: "oculus",
            requestBody: requestBody
        };

        const response = await apiCaller(request);
        if (response.status === 200) {
            const batchResults = response.data.packageResultList || [];
            totalRowCount += batchResults.length;
            results.push.apply(results, transformFn(batchResults));
            paginationToken = response.data.paginationToken || null;

            if (batchResults.length === 0 || totalRowCount >= maxRows) {
                paginationToken = null;
            }
        } else {
            return { results: null, totalRowCount };
        }

        // Wait 1 second before fetching the next page if the feature is
        // enabled. Skipped on the last page since no further call is made.
        if (paginationToken && isOneSecDelayEnabled) {
            await delay(ONE_SECOND_DELAY_MS);
        }
    } while (paginationToken);

    return { results, totalRowCount };
}



// WEBPACK FOOTER //
// ./src/commons/api/PaginatedFetchUtil.js